import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/app/components/DiscordCommunitySection.tsx");
